// Corporate Fiscal Data - REYES DULZURA SOCIEDAD LIMITADA
// Official data for invoicing, legal compliance and Verifactu regulations

export const COMPANY_FISCAL_DATA = {
  razonSocial: "REYES DULZURA SOCIEDAD LIMITADA",
  razonSocialCorta: "REYES DULZURA S.L.",
  cif: "B76363654",
  formaJuridica: "Sociedad Limitada (S.L.)",
  cnae: "1071",
  actividadPrincipal: "Fabricación de pan y productos frescos de panadería y pastelería",
  registroMercantil: "Registro Mercantil de Las Palmas",
  añoFundacion: 1979,
};

// Location-specific fiscal data with addresses for tickets
export const LOCATION_FISCAL_DATA: Record<string, { 
  name: string; 
  address: string; 
  phone: string; 
  serieFactura: string;
  fullAddress: string;
  tpvId: string;
}> = {
  "siete-palmas": {
    name: "Pastelería Reyes - Siete Palmas",
    address: "Av. Pintor Felo Monzón, 2",
    fullAddress: "Av. Pintor Felo Monzón, 2, 35019 Las Palmas de Gran Canaria",
    phone: "928 13 71 95",
    serieFactura: "SP",
    tpvId: "TPV-SP-001",
  },
  "lomo-frailes": {
    name: "Pastelería Reyes - Lomo Los Frailes",
    address: "Calle Jordán, 42",
    fullAddress: "Calle Jordán, 42, 35018 Las Palmas de Gran Canaria",
    phone: "928 66 59 67",
    serieFactura: "LF",
    tpvId: "TPV-LF-001",
  },
  // Legacy codes for backward compatibility
  "felo-monzon": {
    name: "Pastelería Reyes - Siete Palmas",
    address: "Av. Pintor Felo Monzón, 2",
    fullAddress: "Av. Pintor Felo Monzón, 2, 35019 Las Palmas de Gran Canaria",
    phone: "928 13 71 95",
    serieFactura: "SP",
    tpvId: "TPV-SP-001",
  },
  "jordan": {
    name: "Pastelería Reyes - Lomo Los Frailes",
    address: "Calle Jordán, 42",
    fullAddress: "Calle Jordán, 42, 35018 Las Palmas de Gran Canaria",
    phone: "928 66 59 67",
    serieFactura: "LF",
    tpvId: "TPV-LF-001",
  },
};

// IGIC tax rate for Canary Islands (7% general rate)
export const IGIC_RATE = 0.07;

// Legal footer text for web compliance
export const LEGAL_FOOTER_TEXT = `© ${new Date().getFullYear()} ${COMPANY_FISCAL_DATA.razonSocial} - CIF: ${COMPANY_FISCAL_DATA.cif}. Inscrita en el ${COMPANY_FISCAL_DATA.registroMercantil}. Sistema adaptado a normativa Verifactu.`;

// Verifactu compliance text for tickets
export const VERIFACTU_TEXT = "Factura generada por sistema informático Verifactu conforme a RD 1007/2023";
